import type { ExceptionOption } from '../../types/@types/product';

export default function ExceptionsGroup({
  options,
  selected,
  onToggle,
}: {
  options: ExceptionOption[];
  selected: string[];
  onToggle: (key: string) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {options
        .filter((o) => o.active)
        .map((opt) => {
          const isOn = selected.includes(opt.key);
          return (
            <button
              key={opt.key}
              type="button"
              onClick={() => onToggle(opt.key)}
              className={`px-3 py-1 rounded-full text-sm border ${isOn ? 'bg-gray-900 text-white' : 'bg-white'}`}
              aria-pressed={isOn}
            >
              {opt.name}
            </button>
          );
        })}
    </div>
  );
}
